export function getMatchDetailLabel(value?: string | null) {
  return value?.trim() || "غير معلن";
}
